import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { UtilityService } from './utility.service';
import { AuthenticationService } from './authentication.service';
import { ENV } from 'config';
import { ANALYTICS_CONSTANTS } from 'config';

declare var ENV_VAR: any;
declare var ENV_PORTAL;
declare var ddo: any;
declare var _satellite: any;
declare var DataMappingInterface: any;


@Injectable()
export class AdobeAnalyticsService {

  user: UserProfileModel;
  dataLayer: any;
  dataMappingObj: any;

  constructor(private utilityService: UtilityService,
    private router: Router, private authenticationService: AuthenticationService) {
    this.dataLayer = Object.assign({});
    this.dataMappingObj = this.initDataMappingObj();
    this.user = new UserProfileModel();
  }

  initDataMappingObj() {
    return {
      'eventAction': null,
      'eventCode': null,
      'dataset': null,
      'eddsupported': false
    };
  }

  setDataLayer(dataLayer) {
    this.dataLayer = Object.assign({}, dataLayer);
  }

  getDataLayer() {
    return this.dataLayer;
  }

  setDataMappingObj(dataMappingObj) {
    this.dataMappingObj = dataMappingObj;
  }

  getDAtaMappingObj() {
    return this.dataMappingObj;
  }

  setGlobalUserAttributes() {
    this.user = this.authenticationService.getUser();
    if (this.dataLayer && this.user) {
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_PRELOGIN_USER_ID] = this.user.userId;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_USER_ID] = this.user.userId;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_TYPE] = ANALYTICS_CONSTANTS.BC_USER_LOGIN_TYPE;
      //this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_SERVICE_TYPE] = ANALYTICS_CONSTANTS.BC_USER_SERVICE_TYPE;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_ACCOUNT_FOCUS_TYPE] = ANALYTICS_CONSTANTS.BC_USER_ACCOUNT_FOCUS_TYPE;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_BILLING_SYSTEM] = ANALYTICS_CONSTANTS.BC_USER_BILLING_SYSTEM_VAL;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LIABILITY_TYPE] = ANALYTICS_CONSTANTS.BC_USER_LIABILITY_TYPE_VAL;
      //this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_TECH_LANGUAGE] = navigator.language;
      //this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_TECH_USER_AGENT] = navigator.userAgent;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_ABS_COMPANY_ROLE] = ANALYTICS_CONSTANTS.BC_USER_ABS_COMPANY_ROLE_VAL;
      if (this.user.impersonator && this.user.impersonator.type) {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_ABS_ACTOR_TYPE] = this.user.impersonator.type;
      } else {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_ABS_ACTOR_TYPE] = 'Customer';
      }
      //this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_APP_VISITOR_KEY] = document.cookie;
      if (this.user.clientIPAddress) {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR] = this.user.clientIPAddress;
      }
      if (this.user.fanList) {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FAN] = this.user.fanList.length > 0 ? this.user.fanList[0] : '';
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_ABS_COMPANY_NAME] = this.user.fans.length > 0 ? this.user.fans[0].fanName : '';
        if (this.user.fans.length > 0) {
          this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LIBERTY_FLAG] = (this.user.fans[0].libertyIndicator == "TRUE") ? '1' : '0';
          console.log("libertyflag:", this.user.fans[0].libertyIndicator);
        } else {
          this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LIBERTY_FLAG] = '0';
        }
      }
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_ABS_COMPANY_NAME] = ''; // FAN NAME
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR] = ''; // IP ADDRS
      /**
       * Optional Parameters.
       */
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_WIRELESS_ACCOUNT_STATUS] = '';
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_PREMIER_ENTERPRISE_TYPE] = '';
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_MIMIC_ATTUID] = '';
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_MIMIC_PREMIER_AGREEMENT_NUMBER] = '';
      //  this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_MIMIC_ALT_SEGMENT_TYPE] = '';
      // this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_MIMIC_PREMIER_ENTERPRISE_TYPE] = '';

    }
  }

  setGlobalPageAttributes() {
    if (this.dataLayer) {
       if(this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] === undefined || this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] === null){
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = window.location.pathname;
      }
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = ANALYTICS_CONSTANTS.BC_LANGUAGE_EN;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LINE_OF_BUSINESS] = ANALYTICS_CONSTANTS.BC_LINE_OF_BUSINESS_VAL;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_RESPONSIVE_FLAG] = ANALYTICS_CONSTANTS.RESPONSIVEDESIGNFLAG_1;
      // this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ZIP_CODE] = ANALYTICS_CONSTANTS.BC_LINE_OF_BUSINESS_VAL;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_OWNER_SHIP] = ANALYTICS_CONSTANTS.BC_BUSINESS_VAL;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_APP_NAME] = ANALYTICS_CONSTANTS.BC_APP_NAME_VAL;
      this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_APP_CODE] = ANALYTICS_CONSTANTS.BC_APP_CODE_VAL;
      let pathNames = window.location.pathname.split('/').filter(data => (data && data !== 'businessconsole'));
      if (navigator.userAgent.toLowerCase().match('mobile')) {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_VIEWED_UI_EXPERIENCE] = ANALYTICS_CONSTANTS.BC_MOBILE;
      } else {
        this.dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_VIEWED_UI_EXPERIENCE] = ANALYTICS_CONSTANTS.BC_DESKTOP;
      }

      let index = 0;
      for (const path of pathNames) {
        let siteSection = (index > 0) ? ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SUB_SECTION + index :
          ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION;
        this.dataLayer[siteSection] = path.substring(0, 1).toUpperCase() + path.substring(1).toLowerCase();
        index++;
      }
    }
  }

  tag(tagType, dataLayer, eventCode, eventAction) {
    if (sessionStorage.getItem('sapmp_jwtToken') != null && ENV_PORTAL === 'fnabc') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
    }
    this.dataMappingObj = this.initDataMappingObj();
    if (typeof ddo === 'undefined' || typeof _satellite === 'undefined') {
      setTimeout(() => {
        this.prepareBeaconObject(tagType, dataLayer, eventCode, eventAction);
        console.log('dataMappingObj--- If');
        console.log(this.dataMappingObj);
        this.generateBeaconCall();
      }, 5000);
    } else {
      this.prepareBeaconObject(tagType, dataLayer, eventCode, eventAction);
      console.log('dataMappingObj--- Else');
      console.log(this.dataMappingObj);
      this.generateBeaconCall();
    }
  }

  prepareBeaconObject(tagType: string, dataLayer, eventCode: string, eventAction: string) {
    if (tagType === 'page') {
      ddo.disableAutoPageLoad();
      this.dataLayer = Object.assign({}, dataLayer);
      this.setGlobalPageAttributes();
      this.setGlobalUserAttributes();
    } else {
      this.dataLayer = Object.assign({}, dataLayer);
    }
    this.createDataMapObject(eventCode, eventAction);
  }

  createDataMapObject(eventCode, eventAction) {
    this.dataMappingObj[ANALYTICS_CONSTANTS.DATA_SET] = this.dataLayer;
    this.dataMappingObj[ANALYTICS_CONSTANTS.EVENT_ACTION] = eventAction;
    this.dataMappingObj[ANALYTICS_CONSTANTS.EVENT_CODE] = eventCode;
    console.log("inside createDataMapObject"+this.dataMappingObj);
  }

  generateBeaconCall() {
    DataMappingInterface.init(this.dataMappingObj);
    console.log('********************Beacon call executed from Market App************************' +Math.random());
  };

  // page alert adobe analytics set properties
  CreateSeriveAlertProperties(code: number, message: string, event: string, errorType?: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_CODE_ALERT_DISPLAY;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
    if (errorType) {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = errorType;
    } else {
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = ANALYTICS_CONSTANTS.EVENT_ERROR_FAILURE_TYPE_FAILURE_SYSTEM;
    }

    dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_CODE] = code;
    // dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = message;
    this.tag('event', dataLayer, ANALYTICS_CONSTANTS.EVENT_CODE_ALERT_DISPLAY, event);
  }


  /* DMP Adobe Analytics */
  public trackPageProperties() {
    const dataLayer = {};
    const url = this.router.routerState.snapshot.url;
    if (typeof ANALYTICS_CONSTANTS.FRIENDLY_PAGE_URL_NAME[url] !== 'undefined') {
      const friendlyName = ANALYTICS_CONSTANTS.FRIENDLY_PAGE_URL_NAME[url];
      const pageName = ANALYTICS_CONSTANTS.FRIENDLY_PAGE_URL_NAME[url].replace('BC ', '').replace(' Pg', '');
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = url;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyName;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = 'BC~Buy~' + pageName;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
      // dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
      console.log(dataLayer);
      this.tag('page', dataLayer, 'Page_Load', 'pageLoad');
    }
  }

  // EVENT ACTION MATRIX
  public trackEventProperties(data) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.EVENT_CODE] = ANALYTICS_CONSTANTS.EVENT_ACTION_MATRIX[data.code];
    dataLayer[ANALYTICS_CONSTANTS.EVENTS_ERRTYPE] = ANALYTICS_CONSTANTS['EVENT_ERROR_' + data.errorType];
    dataLayer[ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG] = data.successFlag;
    dataLayer[ANALYTICS_CONSTANTS.EVENTS_STATUSMSG] = data.msg;
    // dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    console.log("Event Action Matrix");
    console.log(dataLayer);
    this.tag('event', dataLayer, 'Page_Load', 'formsubmit');
  }

  createAdobeEventProperties( url:string,status: string, event: string, eventcode: string, 
    errorText?: string, errorType?: string,linkName?: string,linkPosition?: string,linkDestinationUrl?: string) {

    let dataLayer = {};

    dataLayer[ANALYTICS_CONSTANTS.EVENT_EVENT_CODE] = eventcode;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_FLOW_CODE] = ANALYTICS_CONSTANTS['FLOW_CODE_'+url];
    dataLayer[ANALYTICS_CONSTANTS.EVENT_LINK_POSITION]=linkPosition;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_LINK_NAME]=linkName;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_LINK_DESTINATIONURL]=linkDestinationUrl;
    
  if(event == 'formResponse' && status == 'SUCCESS'){
    dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
    dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = errorType;
    }
    else if(event == 'formResponse' && status == 'FAILURE') {
    dataLayer[ANALYTICS_CONSTANTS.EVENT_SUCCESS_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_0;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_STATUS_MESSAGE] = errorText;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_ERROR_TYPE] = errorType;
    
    }
    
    this.tag('event', dataLayer, eventcode, event);
    }
    createClickProperties(linkName: string,linkPosition?: string,linkDestinationUrl?: string){
      let dataLayer = {};
      dataLayer[ANALYTICS_CONSTANTS.EVENT_LINK_NAME]=linkName;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_LINK_POSITION]=linkPosition;
      dataLayer[ANALYTICS_CONSTANTS.EVENT_LINK_DESTINATIONURL]=linkDestinationUrl;
      //console.log(dataLayer);
      this.tag('event', dataLayer, 'Link_Click', 'linkClick');
    }
    // added for accesories functionality
    // createButtonProperties(linkSource, linkMedium, linkCampaign )
    // {
    //   let  dataLayer = {};
    //   dataLayer["utmSource"]=linkSource;
    //   dataLayer["utmMedium"]=linkMedium;
    //   dataLayer["utmCampaign"]=linkCampaign;
    //   this.tag('event',dataLayer, 'Button_Click', 'ButtonClick' )

    // }
}

